import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TitleIdToContactUs = {
  [titleId: string]: WpsTypes.atv.wps.ContactUsModelProps | undefined
}

export const reducer = createMergeReducer(
  t => t.contactUs,
  {} as TitleIdToContactUs
)
